const accHostnames = [
  'https://acc-qa.autodesk.com',
  'https://acc-staging.autodesk.com',
  'https://acc.autodesk.com'
];

export default url => (url ? accHostnames.some(h => url.includes(h)) : false);
